import * as Leaflet from 'leaflet'

export default class LeaftletMapObjectLayer extends Leaflet.Layer {
  _container: HTMLDivElement
  options: Leaflet.LayerOptions

  onAdd (map: Leaflet.Map): this {
    this._container = document.createElement('div')
    this._container.className = 'leaflet-map-object-layer'
    const panel = map.getPane(this.options.pane!)!
    panel.appendChild(this._container)
    return this
  }

  onRemove (_map: Leaflet.Map): this {
    const parent = this._container.parentNode
    if (parent) {
      parent.removeChild(this._container.parentNode!)
    }
    return this
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MapObjects/LeaftletMapObjectLayer.ts